import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLibraryBooks = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 375 375",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 38,
			y: 40,
			width: 46,
			height: 295,
			rx: 16
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 98,
			y: 40,
			width: 46,
			height: 295,
			rx: 16
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 158,
			y: 40,
			width: 46,
			height: 295,
			rx: 16
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 211,
			y: 40,
			width: 46,
			height: 284,
			rx: 16,
			transform: "translate(0 25) rotate(-18 211 40)"
		})
	]
});
export default SvgLibraryBooks;
